import { render, staticRenderFns } from "./PrivilegeNotice.vue?vue&type=template&id=cae86ae8&lang=html"
import script from "./PrivilegeNotice.vue?vue&type=script&lang=js"
export * from "./PrivilegeNotice.vue?vue&type=script&lang=js"
import style0 from "./PrivilegeNotice.vue?vue&type=style&index=0&id=cae86ae8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports